// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"SponsoredBanner_sponsoredBanner__3IGqs","margin":"SponsoredBanner_margin__U7QRp","floating":"SponsoredBanner_floating__J2r3W"};